import styled from '@emotion/styled'
import { colors } from '@global/constants'

export const Header = styled.header`
  background-color: #fff;
  padding: 0 50px;
  display: flex;
  justify-content: space-between;
  font-family: 'Noto Sans', sans-serif;
  position: relative;
  grid-gap: 10px;

  &.-no-navlist {
    padding-bottom: 36px;
  }
`

export const TitleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 10px 0 50px;
  position: relative;
`

export const Title = styled.h1`
  color: #000;
  font-size: 30px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  margin: 0;
  white-space: nowrap;
`

export const Meta = styled.div`
  display: flex;
  align-self: flex-end;

  & > section:last-of-type {
    border-right: none;
  }
`

export const MetaDetail = styled.section`
  display: flex;
  flex-direction: column;
  border-right: 1px solid #eee;
  padding: 12px 16px;
  white-space: nowrap;
  overflow: hidden;
  z-index: 1;
`

export const MetaDetailLabel = styled.h1`
  margin: 0;
  font-size: 11px;
  color: ${colors.sonicSilver};
  line-height: 1.65;
`

export const MetaDetailValue = styled.h3`
  margin: 0;
  font-size: 14px;
  color: ${colors.brand.primary};
  overflow: hidden;
  text-overflow: ellipsis;
`
